<template>
    <div>

        <!-- reset form -->
        <div v-if="state == 'reset'">
            <div class="top">
                <h2>Reset your password</h2>
                <p>Enter a new password below reset your login.</p>
            </div>
            <form action="#" @submit.prevent="resetPassword">
                <div class="inprow">
                    <label>New Password</label>
                    <input type="password" name="pass" class="form-control" v-model="pass">
                </div>
                <div class="inprow">
                    <label>Repeat New Password</label>
                    <input type="password" name="repeatpass" class="form-control" v-model="repeat">
                </div>
                <div class="inprow">
                    <b-btn type="submit" variant="secondary" @click.prevent="resetPassword">
                        <LoadingWheel v-if="isSubmitting" />
                        <span v-else>Save Password</span>
                    </b-btn>
                    &nbsp;&nbsp;&nbsp;
                    <a href="#" @click.prevent="$emit('change-state', 'login')">login</a>
                </div>
                <div class="inprow err" v-if="err" v-html="err"></div>
            </form>
        </div>

        <!-- reset success state -->
        <div v-if="state == 'done'">
            <div class="top">
                <h2>Password reset</h2>
                <p>You have successfully reset your password. Click the link below to login to your account.</p>
            </div>
            <hr />
            <div class="inprow">
                <a href="#" @click.prevent="login">login</a>
            </div>
        </div>

    </div>
</template>

<script>
import $ from "jquery";
import LoadingWheel from './LoadingWheel.vue';

//
export default {
    name: 'AgentResetPassword',
    created() {

        //set the email and reset key
        this.email = this.queryParams.get('email');
        this.reset_key = this.queryParams.get('reset');

    },
    components: {
        LoadingWheel
    },
    data() {
        return {
            state: 'reset',
            email: "",
            reset_key: "",
            pass: "",
            repeat: "",

            isSubmitting: false,
            err: false

        };
    },
    computed: {

        queryParams() {
            return new URLSearchParams(window.location.search);
        },

    },
    methods: {

        //
        resetPassword() {
            var _this = this;

            //validate
            if( this.pass.length < 6 ) return this.err = "New password must be a minimum of 6 characters long.";
            if( this.pass !== this.repeat ) return this.err = "The passwords entered do not match";

            //
            if( this.isSubmitting ) return;
            this.isSubmitting = true;
            this.err = false;
            
            
            //
            $.ajax({
                url: window.CoachingPanel.ajaxurl,
                type: 'post',
                data: {
                    email: this.email,
                    pass: this.pass,
                    key: this.reset_key,
                    action: 'cpagentresetpass'
                },
                success: function() {

                    //update the state
                    _this.state = 'done';
                    
                },
                error: function( data ) {

                    _this.err = data.responseJSON.message;
                    _this.isSubmitting = false;

                }
            });

        },

        //
        login() {
            // this.$emit('change-step', 'login');
            window.location.replace(window.location.href.split("?")[0]);
        }

    }
};
</script>
